"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  registerReducer: true,
  registerMiddleware: true,
  CourierContext: true,
  CourierProvider: true
};
exports.CourierProvider = exports.CourierContext = exports.registerMiddleware = exports.registerReducer = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _createReducer = _interopRequireDefault(require("react-use/lib/factory/createReducer"));

var _reactHooks = require("@trycourier/react-hooks");

var _reducer = _interopRequireWildcard(require("./reducer"));

var _middleware = _interopRequireWildcard(require("./middleware"));

var _useCourierActions = _interopRequireDefault(require("./hooks/use-courier-actions"));

var _usePageVisible = require("./hooks/use-page-visible");

var _useClientSourceId = _interopRequireDefault(require("./hooks/use-client-source-id"));

var _deepExtend = _interopRequireDefault(require("deep-extend"));

var _theme2 = require("./theme");

var _useIsOnline = require("./hooks/use-is-online");

var _useListenForTransport = require("./hooks/use-listen-for-transport");

var _hooks = require("./hooks");

Object.keys(_hooks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _hooks[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _hooks[key];
    }
  });
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

if (typeof window !== "undefined") {
  window.global = window; // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-var-requires

  window.Buffer = window.Buffer || require("buffer").Buffer;
}

var registerReducer = _reducer.registerReducer;
exports.registerReducer = registerReducer;
var registerMiddleware = _middleware.registerMiddleware;
exports.registerMiddleware = registerMiddleware;

var GlobalThemeVariables = function GlobalThemeVariables(_ref) {
  var variables = _ref.variables;
  (0, _react.useEffect)(function () {
    var setGlobalThemeVariables = function setGlobalThemeVariables(variables) {
      var _variables$background, _variables$textColor, _variables$titleColor, _variables$structure, _variables$icon;

      var root = document.documentElement;
      root.style.setProperty("--ci-background", (_variables$background = variables === null || variables === void 0 ? void 0 : variables.background) !== null && _variables$background !== void 0 ? _variables$background : null);
      root.style.setProperty("--ci-text-color", (_variables$textColor = variables === null || variables === void 0 ? void 0 : variables.textColor) !== null && _variables$textColor !== void 0 ? _variables$textColor : null);
      root.style.setProperty("--ci-title-color", (_variables$titleColor = variables === null || variables === void 0 ? void 0 : variables.titleColor) !== null && _variables$titleColor !== void 0 ? _variables$titleColor : null);
      root.style.setProperty("--ci-structure", (_variables$structure = variables === null || variables === void 0 ? void 0 : variables.structure) !== null && _variables$structure !== void 0 ? _variables$structure : null);
      root.style.setProperty("--ci-icon", (_variables$icon = variables === null || variables === void 0 ? void 0 : variables.icon) !== null && _variables$icon !== void 0 ? _variables$icon : null);
    };

    setGlobalThemeVariables(variables);
  }, [variables]);
  return null;
};

var CourierContext = /*#__PURE__*/_react["default"].createContext(undefined);

exports.CourierContext = CourierContext;

var CourierProviderInner = function CourierProviderInner(_ref2) {
  var _window;

  var apiUrl = _ref2.apiUrl,
      authorization = _ref2.authorization,
      brand = _ref2.brand,
      brandId = _ref2.brandId,
      children = _ref2.children,
      clientKey = _ref2.clientKey,
      id = _ref2.id,
      tenantId = _ref2.tenantId,
      _theme = _ref2.theme,
      inboxApiUrl = _ref2.inboxApiUrl,
      _ref2$localStorage = _ref2.localStorage,
      localStorage = _ref2$localStorage === void 0 ? typeof window !== "undefined" ? (_window = window) === null || _window === void 0 ? void 0 : _window.localStorage : undefined : _ref2$localStorage,
      applyMiddleware = _ref2.applyMiddleware,
      onMessage = _ref2.onMessage,
      onRouteChange = _ref2.onRouteChange,
      _transport = _ref2.transport,
      userId = _ref2.userId,
      userSignature = _ref2.userSignature,
      _ref2$wsOptions = _ref2.wsOptions,
      _wsOptions = _ref2$wsOptions === void 0 ? {} : _ref2$wsOptions;

  var wsOptions = (0, _react.useMemo)(function () {
    return _wsOptions;
  }, [_wsOptions.connectionTimeout, _wsOptions.onClose, _wsOptions.onError, _wsOptions.onReconnect, _wsOptions.url]);
  var clientSourceId = (0, _useClientSourceId["default"])({
    authorization: authorization,
    clientKey: clientKey,
    id: id,
    localStorage: localStorage,
    userId: userId
  });
  var middleware = (0, _react.useMemo)(function () {
    if (!applyMiddleware) {
      return _middleware["default"];
    }

    return applyMiddleware(_middleware["default"]);
  }, [applyMiddleware]);
  var useReducer = (0, _react.useCallback)(_createReducer["default"].apply(void 0, (0, _toConsumableArray2["default"])(middleware)), [middleware]);
  var isOnline = (0, _useIsOnline.useIsOnline)();
  var transport = typeof window === "undefined" ? undefined : (0, _reactHooks.useTransport)({
    authorization: authorization,
    clientKey: clientKey,
    clientSourceId: clientSourceId,
    isOnline: isOnline,
    tenantId: tenantId,
    transport: _transport,
    userSignature: userSignature,
    wsOptions: wsOptions
  });
  var theme = (0, _react.useMemo)(function () {
    var _theme$variables;

    return _objectSpread(_objectSpread({}, _theme), {}, {
      variables: (0, _deepExtend["default"])({}, (_theme === null || _theme === void 0 ? void 0 : _theme.colorMode) === "dark" ? _theme2.darkVariables : _theme2.lightVariables, (_theme$variables = _theme === null || _theme === void 0 ? void 0 : _theme.variables) !== null && _theme$variables !== void 0 ? _theme$variables : {})
    });
  }, [_theme]);

  var _useReducer = useReducer(_reducer["default"], {
    apiUrl: apiUrl,
    authorization: authorization,
    brand: brand,
    brandId: brandId,
    clientKey: clientKey,
    clientSourceId: clientSourceId,
    inboxApiUrl: inboxApiUrl,
    localStorage: localStorage,
    onRouteChange: onRouteChange,
    tenantId: tenantId,
    transport: transport,
    userId: userId,
    userSignature: userSignature
  }),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var actions = (0, _useCourierActions["default"])(state, dispatch);
  (0, _usePageVisible.usePageVisible)(function (isVisible) {
    if (!isVisible) {
      return;
    } // this means we left the tab and came back so we should refetch


    actions.pageVisible();
  });
  (0, _react.useEffect)(function () {
    if (_transport) {
      // this means the transport was passed in and we shouldn't subscribe
      return;
    }

    if (!transport || !userId) {
      return;
    }

    var courierTransport = transport;
    courierTransport.subscribe(userId);
    courierTransport.onReconnection({
      id: "handleWSReconnection",
      callback: function callback() {
        actions.wsReconnected();
      }
    });

    if (onMessage) {
      courierTransport.intercept(onMessage);
    }

    var intervalId = setInterval(function () {
      courierTransport.keepAlive();
    }, 300000); // 5 minutes

    return function () {
      clearInterval(intervalId);
      courierTransport.unsubscribe(userId);
      courierTransport.closeConnection();
    };
  }, [tenantId, actions, transport, userId]);
  (0, _react.useEffect)(function () {
    var hasClientKeyAuth = clientKey && userId;
    var hasCustomTransport = Boolean(_transport);
    var hasJWTAuth = Boolean(authorization);

    if (!hasCustomTransport && !hasClientKeyAuth && !hasJWTAuth) {
      return;
    }

    var parsedLocalStorageState;

    if (state.localStorage) {
      var localStorageState = state.localStorage.getItem("".concat(clientKey, "/").concat(userId, "/provider"));

      if (localStorageState) {
        try {
          parsedLocalStorageState = JSON.parse(localStorageState);
        } catch (ex) {
          console.error(ex);
        }
      }
    }

    actions.init(_objectSpread({
      apiUrl: apiUrl,
      authorization: authorization,
      brandId: brandId,
      clientKey: clientKey,
      inboxApiUrl: inboxApiUrl,
      localStorage: localStorage,
      tenantId: tenantId,
      transport: transport,
      userId: userId,
      userSignature: userSignature
    }, parsedLocalStorageState));
  }, [actions, apiUrl, authorization, brandId, clientKey, inboxApiUrl, localStorage, tenantId, transport, userId, userSignature]);
  (0, _react.useEffect)(function () {
    if (!state.brand || !clientKey || !userId || !state.localStorage) {
      return;
    }

    state.localStorage.setItem("".concat(clientKey, "/").concat(userId, "/provider"), JSON.stringify({
      brand: state.brand
    }));
  }, [state.brand, clientKey, userId, state.localStorage]);
  (0, _useListenForTransport.useListenForTransportEvent)({
    transport: transport,
    createTrackEvent: actions.createTrackEvent
  });
  return /*#__PURE__*/_react["default"].createElement(CourierContext.Provider, {
    value: _objectSpread(_objectSpread(_objectSpread({}, state), actions), {}, {
      clientSourceId: clientSourceId
    })
  }, /*#__PURE__*/_react["default"].createElement(GlobalThemeVariables, {
    variables: theme.variables
  }), children);
};

var CourierProvider = function CourierProvider(props) {
  if (!props.clientKey && !props.authorization) {
    console.warn("Missing ClientKey or Authorization Token");
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.children);
  }

  return /*#__PURE__*/_react["default"].createElement(CourierProviderInner, props);
};

exports.CourierProvider = CourierProvider;